import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import Shortcode from "src/libs/useful/shortcode"
import { ILandingPrimitive, LANDING_PRIMITIVE_TYPE } from "../../../data/interfaces"
import { components } from "../../../data/utils/components"
import { getCssDemention } from "../../../../../libs/utilities/getCssDemention"
import { Heart, Rectangle, Star } from "./" 
import { IPrimitiveProps } from "../section/Primitive"
import OrderPrimitive from "./OrderPrimitive"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import Oval from "./Oval"
import Curve from "./Curve"
import usePrimitiveData from "src/modules/pe-landing-module/hooks/usePrimitiveData"

/* Protopia Ecosystem component */ 
const PrimitiveContent = ( props: IPrimitiveProps): JSX.Element => {
    //const primitive: any =  props.primitive || {}
    const primitive= usePrimitiveData( props.primitive  || {} as ILandingPrimitive )
    const {position} = usePosition(primitive)
    
    useEffect(() => {
        addCSSClass(
            `primitive-${primitive.id}`,
            `.primitive-${primitive.id} {
                left: ${getCssDemention(position?.left, "0px")};
                top: ${getCssDemention(position?.top, "0px")};
                width: ${getCssDemention(position?.width, "100px")};
                height: ${getCssDemention(position?.height, "100px")};
                opacity: ${ position?.opacity || 1};
                transform: rotate(${position?.rotate || 0}deg) scale(${position.scale || 1});
            }            
            `
        )
        return () => {
            removeCSSClass( `primitive-${primitive.id}` )
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ position ])
    
    
    if(!primitive.type) {
        return <Shortcode content={JSON.stringify( primitive ) || "no content type"} />
    }
    switch(primitive.type) {
        case LANDING_PRIMITIVE_TYPE.STAR:
            return <Star 
                primitive={primitive} 
                {
                    ...{ "data-content-id": props["data-content-id"] }
                }  
            />
        case LANDING_PRIMITIVE_TYPE.HEART:
            return <Heart 
                primitive={primitive} 
                {
                    ...{ "data-content-id": props["data-content-id"] }
                }  
            />
        case LANDING_PRIMITIVE_TYPE.RECTANGLE:
            return <Rectangle 
                primitive={primitive} 
                {
                    ...{ "data-content-id": props["data-content-id"] }
                }  
            />  
        case LANDING_PRIMITIVE_TYPE.OVAL:
            return <Oval 
                primitive={primitive} 
                {
                    ...{ "data-content-id": props["data-content-id"] }
                }  
            /> 
        case LANDING_PRIMITIVE_TYPE.ORDER:
            return <OrderPrimitive 
                primitive={primitive} 
                {
                    ...{ "data-content-id": props["data-content-id"] }
                }  
            /> 
        case LANDING_PRIMITIVE_TYPE.CURVE:
            return <Curve 
                primitive={primitive} 
                {
                    ...{ "data-content-id": props["data-content-id"] }
                }  
            /> 
        default:
            const DataComponent = !!components()[ primitive.type ]
                ?
                components()[ primitive.type ].primitive
                :
                "div"  
            return <DataComponent                 
                primitive={primitive} 
                {
                    ...{ "data-content-id": props["data-content-id"] }
                }  
            
            />
    }
}
export default PrimitiveContent